import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as StackTrace from 'stacktrace-js';

import { AuthService, HorizonLogger } from '@bayclubs/horizon';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private log: HorizonLogger, private authService: AuthService) {
        console.log('init error interceptor');
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {
                StackTrace.get().then(x => {
                    const identity = this.authService.userName() ?? '';
                    const stringifiedStack = x
                        .map(function(sf) {
                            return sf.toString();
                        })
                        .join('\n');

                    this.log.error(
                        'Http error. Status code: ' +
                            error.status +
                            ' .Request url: ' +
                            error.url +
                            ' .Api Url: ' +
                            req.url +
                            ' .Status text: ' +
                            error.statusText,
                        error,
                        null,
                        { identity, stack: stringifiedStack }
                    );
                });

                return throwError(error);
            })
        );
    }
}
